import { z } from 'zod';

import { BankruptcyId } from '../BrandedIds';
import { zodJSPlainDate } from '../dates/BrandedDate';
import { BankruptcyOutcome, BankruptcyStatus } from '../loan/Bankruptcy';
import { ReportableEventInput } from '../loan/ReportableEvent';
import { BaseLoanEvent } from './BaseLoanEvent';

export const CloseBankruptcyEvent = BaseLoanEvent.extend({
  type: z.literal('closeBankruptcy'),
  bankruptcyId: BankruptcyId,
  status: BankruptcyStatus,
  endOutcome: BankruptcyOutcome.optional(),
  endDate: zodJSPlainDate.optional(),
  reportableEvent: ReportableEventInput.optional(),
  comment: z.string().optional(),
});
export type CloseBankruptcyEvent = z.infer<typeof CloseBankruptcyEvent>;
